import Components from './../Component';
//import Swiper from 'swiper';

export default class Gallery extends Components {
  constructor($) {
    super($);
  }

  init(index, element) {
    this.thumbnailGallery = new Swiper(this.$(element).find('.swiper-container'), {
      slidesPerView: 'auto',
      spaceBetween: 25,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboardControl: true
    });

    this.lightboxGallery = new Swiper(this.$(element).find('.swiper-zoom-container'), {
      slidesPerView: 'auto',
      spaceBetween: 25,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      centeredSlides: true,
      keyboardControl: true
    });

    this.lightboxGallery.on('slideChange', function () {
      console.log('slide changed');

      this.setIndex(this.lightboxGallery.activeIndex, element);
      this.thumbnailGallery.slideTo(this.lightboxGallery.activeIndex, 0);
    }.bind(this));

    this.thumbnailGallery.slides.each(function (i, slide) {
      this.$(slide).on('click', function (e) {
        this.toggleLightbox(element);
        this.lightboxGallery.slideTo(i, 0);
      }.bind(this));
    }.bind(this));

    this.$(element).find('#closeLightbox').on('click', function () {
      this.toggleLightbox(element);
    }.bind(this));

    this.$(document).keyup(function (e) {
      if (e.keyCode == 27 && this.$(element).find('.gallery-lightbox').hasClass('open')) {
        this.toggleLightbox(element);
      }
    }.bind(this));
  }

  toggleLightbox(element) {
    this.$(element).find('.gallery-lightbox').toggleClass('open');
  };

  setIndex(index, element) {
    console.log('set index', index);
    this.$(element).find('.swiper-indicator-active').text(index + 1);
  }

}
